import { PrivateRoute } from ".";
import { Outlet } from "react-router-dom";

import StaffForum from "../pages/staff/StaffForum";
import StaffInbox from "../pages/staff/StaffInbox";
import StaffProgress from "../pages/staff/StaffProgress";
import DocsCheckHome from "../pages/staff/DocsCheckHome";
import DocsCheck from "../pages/staff/DocsCheck";
import StaffMaterial from "../pages/staff/StaffMaterial";
import MaterialDirectories from "../pages/common/MaterialDirectories";
import { Home } from "../components/Navigation";
import Header from "../components/Header";
import Announcement from "../pages/common/Announcement";
import AddAnnouncement from "../pages/staff/AddAnnouncement";
import AnnouncementDetail from "../pages/common/AnnouncementDetail";
import QnA from "../pages/common/QnA";
import FaQ from "../pages/common/FaQ";
import QnaDetail from "../pages/common/QnaDetail";
import QnaAnswer from "../pages/staff/QnaAnswer";
import Training from "../pages/staff/Training";
import ManageInstructor from "../pages/staff/ManageInstructor";
import ScoreUpdate from "../pages/staff/ScoreUpdate";

const staffRoutes = [
  {
    path: "staff",
    element: (
      <PrivateRoute role="staff">
        <Header role="staff" />
        <div className="content">
          <Outlet />
        </div>
      </PrivateRoute>
    ),
    children: [
      {
        path: "",
        element: <Home role="staff" />,
      },
      {
        path: "progress",
        element: <StaffProgress />,
      },
      {
        path: "score",
        element: <ScoreUpdate />,
      },
      {
        path: "announcement",
        children: [
          {
            path: "",
            element: <Announcement role="staff" />,
          },
          {
            path: ":id",
            element: <AnnouncementDetail />,
          },
          {
            path: "new",
            element: <AddAnnouncement />,
          },
        ],
      },
      {
        path: "qna",
        children: [
          {
            path: "",
            element: <QnA role="staff" />,
          },
          {
            path: "inbox",
            element: <StaffInbox />,
          },
          {
            path: "forum",
            children: [
              {
                path: "",
                element: <StaffForum />,
              },
              {
                path: ":id",
                element: <QnaDetail role="staff" />,
              },
              {
                path: "answer/:id",
                element: <QnaAnswer />,
              },
            ],
          },
        ],
      },
      {
        path: "material",
        element: <MaterialDirectories role="staff" />,
        children: [
          {
            path: "",
            element: <h4>자료 종류를 선택해 주세요.</h4>,
          },
          {
            path: ":department/:directory",
            element: <StaffMaterial />,
          },
        ],
      },
      {
        path: "docs",
        children: [
          {
            path: "",
            element: <DocsCheckHome />,
          },
          {
            path: ":directory",
            element: <DocsCheck />,
          },
        ],
      },
      {
        path: "training",
        children: [
          {
            path: "",
            element: <Training />,
          },
        ],
      },
      {
        path: "instructor",
        children: [
          {
            path: "",
            element: <ManageInstructor />,
          },
        ],
      },
      {
        path: "faq",
        element: <FaQ role="staff" />,
      },
    ],
  },
];

export default staffRoutes;
